var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"congratulations"},[_c('img',{attrs:{"src":require("@/assets/images/congratulations.svg"),"alt":"congratulations","width":"24","height":"22"}}),_c('h3',[_vm._v("Thank you for donating your voice!")])])}]

export { render, staticRenderFns }